<template>
  <div>
    <div class="animation">
      <img v-if="giantBear" class="giant-bear" :class="{'slide': giantSlide}" src="./images/giant_normal.svg" alt="">
      <img v-if="littleBear" class="little-bear" srcset="./images/shrunk_bear.png 1x, ./images/shrunk_bear@2x.png 2x" src="./images/shrunk_bear@2x.png" alt="">
      <div class="conveyor" :class="animationStage"></div>
      <div class="shrink-ray" :class="rayOff? 'off': ''"></div>
      <div v-if="!rayOff" class="sparkle" :class="animationStage"></div>
      <div v-if="rayOff" class="smoke-puff" :class="{'puff-animate': puffCloudAnimate}"></div>
      <div v-show="littleBear" class="smoking"></div>
    </div>
    <div v-if="timer > 0" class="copy text-center">
      <h3>Downgrading in {{ timer }} second<span v-if="timer > 1">s</span></h3>
      <button class="btn btn-lg mtop-20" @click="cancelAnimation()">Cancel Downgrade</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'downgrade-animation',
  data () {
    return {
      animationStage: 'one',
      giantBear: true,
      giantSlide: false,
      littleBear: false,
      timer: 10,
      puffCloudAnimate: false
    }
  },
  computed: {
    rayOff: function () {
      if (this.timer > 9 || this.timer < 1) return true
    }
  },
  methods: {
    runAnimation: function (index, status) {
      if (status === 'stop') return
      if (!this.giantSlide) this.giantSlide = true

      let stages = ['one', 'two', 'three']
      this.animationStage = stages[index]

      setTimeout(() => {
        if (this.timer > 0) {
          if (index < stages.length - 1) {
            index++
            this.runAnimation(index, 'run')
          } else {
            this.runAnimation(0, 'run')
          }
        } else {
          this.runAnimation(index, 'stop')
          this.puffCloudAnimate = true

          setTimeout(() => {
            this.giantBear = false
            this.littleBear = true
          }, 200)
          this.$emit('animationComplete')
        }
      }, 70)
    },
    runCountdown: function () {
      setTimeout(() => {
        this.timer--
        if (this.timer > 0) {
          this.runCountdown()
        }
      }, 1000)
    },
    cancelAnimation: function () {
      this.runAnimation(0, 'stop')
      this.$emit('cancelDowngrade')
    }
  }
}
</script>

<style scoped lang="stylus" src="./downgrade-animation.styl" >



// WEBPACK FOOTER //
// src/components/downgrade-animation/downgrade-animation.vue